module.exports = __webpack_public_path__ + "static/img/099_TO8_1779.8e1aaa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/099_TO8_1779.jpg
// module id = mbIU
// module chunks = 0